"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var button_1 = __importDefault(require("../../atoms/button"));
exports.buttonBuilder = function (props) { return React.createElement(button_1.default, __assign({}, props)); };
exports.actionToButtonProps = function (_a, item) {
    var icon = _a.icon, handler = _a.handler, label = _a.label, disabled = _a.disabled, href = _a.href, target = _a.target;
    return ({
        icon: icon,
        onClick: handler ? function (evt) { return handler(evt, item); } : null,
        label: label,
        disabled: disabled,
        href: href,
        target: target
    });
};
//# sourceMappingURL=action-builder.js.map